require('../../../modules/es.array.concat');

var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').concat;